import { ConnectedAccountApiPath } from 'common/enums/services/api/paths/connected-account-api-path.enum';
import { axiosInstance } from './axiosInstance';
import { ConnectedAccountDto } from 'common/types/services/api/payment/connected-account-dto.type';

export const createConnectedAccount = (): Promise<string> => {
  return axiosInstance.post(`${ConnectedAccountApiPath.CONNECTED_ACCOUNT}`);
};

export const createConnectedAccountSession = (connectedAccountId: string): Promise<string> => {
  return axiosInstance.post(`${ConnectedAccountApiPath.CONNECTED_ACCOUNT_SESSION}`, { connectedAccountId });
};

export const getConnectedAccount = (): Promise<ConnectedAccountDto> => {
  return axiosInstance.get(`${ConnectedAccountApiPath.CONNECTED_ACCOUNT}`);
};

export const updateConnectedAccount = (): Promise<void> => {
  return axiosInstance.put(`${ConnectedAccountApiPath.CONNECTED_ACCOUNT}`, {});
};

export const getExpressDashboardLoginLink = (connectedAccountId: string): Promise<string> => {
  return axiosInstance.get(`${ConnectedAccountApiPath.CONNECTED_ACCOUNT}/expressDashboard/login/${connectedAccountId}`);
};
